import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("No root element found");

initSentry();
initGtm();

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

function initSentry() {
  Sentry.init({
    dsn: "https://0e6fde377fbddc265c9de7b85a0733aa@us.sentry.io/4506698262839296",
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    enabled: import.meta.env.PROD,
    environment: import.meta.env.MODE,
    ignoreErrors: [
      "Failed to fetch",
      "Load failed",
      "NetworkError when attempting to fetch resource.",
    ],
  });
}

function initGtm() {
  const script = document.createElement("script");

  // NOTE: 埋め込み先と名前が被らないようにするため、idealGtmDataLayerを利用するようにスニペットを書き換えている
  // https://developers.google.com/tag-manager/devguide?hl=ja#renaming
  script.text = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','idealGtmDataLayer','${import.meta.env.VITE_GTM_CONTAINER_ID}');
  `;

  const head = document.getElementsByTagName("head")[0];
  head.appendChild(script);

  const noscript = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${import.meta.env.VITE_GTM_CONTAINER_ID}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.cssText = "display:none;visibility:hidden";

  noscript.appendChild(iframe);
  head.appendChild(noscript);
}
